import { api } from './client'
import type { JournalEntry } from '@/types'

export type SearchKind = 'all' | 'journal' | 'note'
export type SearchDateRange = 'week' | 'month' | 'year' | 'all'

export interface SearchResult {
  id: string
  kind: 'journal' | 'note'
  body: string
  snippet: string
  createdAt: string
  entryDate?: string
  journalType?: JournalEntry['type']
  aiExcludable?: boolean
  priorityId?: string | null
  bucketId?: string | null
  entityName?: string
}

export function fetchSearchResults(
  query: string,
  kind: SearchKind,
  dateRange: SearchDateRange,
  journalType: JournalEntry['type'] | null,
): Promise<SearchResult[]> {
  const params = new URLSearchParams({ q: query, kind, dateRange })
  if (journalType) params.set('journalType', journalType)
  return api.get(`/api/search?${params.toString()}`)
}
